import React from 'react';
import { Link } from 'gatsby';
import ItemTags from '../ItemTags/ItemTags';
import * as styles from './item.module.css';
import useSiteMetadata from '../../utils/useSiteMetadata.tsx';
import ItemTag from '../ItemTags/ItemTag';

type Props = {
  post: {
    slug: string;
    title: string;
    date: string;
    tags?: {
      name: string;
      slug: string;
    }[];
    icon?: string;
    year: string;
    banner?: {
      childImageSharp: {
        resize: {
          src: string;
        };
      };
    };
    pic?: {
      childImageSharp: {
        resize: {
          src: string;
        };
      };
      extension;
      publicURL;
    };
  };
  showTags?: boolean;
};

const ListItem = ({ post, showTags = true, year, count }: Props) => {
  const siteMetadata = useSiteMetadata();

  return (
    <div className={`${styles.listItem} ${year ? styles.listItemSpecial : ''}`}>
      {post && (
        <>
          {' '}
          <Link className={styles.hiddenLink} to={post.slug} />
          <div className={styles.header}>
            {post.tags && (
              <div className={styles.headTag}>
                <ItemTag tag={post.tags[0]} />
              </div>
            )}
            {post.year && (
              <span className={styles.headerRight}>{post.year}</span>
            )}
          </div>
          <div className={styles.illustration}>
            {/* <TreeIcon className={styles.icon} /> */}
            {post.pic &&
            !post.pic.childImageSharp &&
            post.pic.extension === 'svg' ? (
              <img src={post.pic.publicURL} alt='pic' />
            ) : (
              post.pic && (
                <img
                  src={post.pic.childImageSharp.resize.src}
                  alt='Project illustration'
                />
              )
            )}
          </div>
          <div className={styles.caption}>
            <div className={styles.title}>
              <Link to={post.slug}>
                {post.title} {post.tagLine ? `- ${post.tagLine}` : ''}
              </Link>
            </div>
            <div className={styles.tags}>
              {post.tags && showTags && (
                <>
                  <ItemTags tags={post.tags.slice(1)} />
                </>
              )}
            </div>
          </div>
        </>
      )}
      {year && (
        <Link
          className={styles.hiddenLink}
          to={`${siteMetadata.tagsPath}/${year}`}
        >
          <span className={styles.yearText}>{year}</span>
          <span className={styles.yearCount}>
            [{count} project{count > 1 ? 's' : ''}]
          </span>
        </Link>
      )}
    </div>
  );
};

export default ListItem;
